import { alpha } from '@mui/material'
import { ThemeSxProps } from '~/ui/theme'

export const buttonStyles: ThemeSxProps = {
  justifyContent: 'space-between',
  color: 'text.disabled',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  '&.active': {
    color: 'text.primary',
    backgroundColor: (t) => alpha(t.palette.text.primary, 0.08),
  },
  '&:hover': { color: 'text.primary' },
}
